import { Component, Host, h, Prop } from '@stencil/core'

@Component({
  tag: 'snap-dropdown-menu-header',
  styleUrl: 'snap-dropdown-menu-header.scss',
  shadow: true,
})
export class SnapDropdownMenuHeader {
  @Prop() title: string
  @Prop() switchProfile: string = ''
  @Prop({mutable: true}) avatarImg: string = ''
  @Prop() isMobile: boolean = false

  imgLoadError() {
    this.avatarImg = ''
  }

  render() {
    return (
      <Host>
        <div class="wrapper">
          {this.avatarImg &&
            <div class="avatar">
              <img src={this.avatarImg} alt="avatar" onError={() => this.imgLoadError()} />
            </div>
          }
          <div class="main-content">
            <h3>{this.title}</h3>
            <div class="description">
              <slot></slot>
            </div>
            { !!this.switchProfile && <snap-link class="switch-profile-link" href={this.switchProfile} target="_blank" size={this.isMobile ? 'sm' : 'xs'}>Switch Profile</snap-link> }
          </div>
        </div>
      </Host>
    )
  }
}
